import script from "./sqmComplainView.vue?vue&type=script&setup=true&lang=js"
export * from "./sqmComplainView.vue?vue&type=script&setup=true&lang=js"

import "./sqmComplainView.vue?vue&type=style&index=0&id=47c4507c&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47c4507c"]])

export default __exports__